/**
 *
 *
 * @param name
 * @param type
 * @param content
 * @param roles
 * @returns {Promise<void>}
 */
import {apiDELETE, apiGET, apiGETPaginated, apiPOST, apiPUT} from "./RequestsCore";

/**
 * Returns all the existing clients with pagination. Objects are in 'data' and pagination is in 'meta' and 'links'.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getClientsPaginated(filters) {
    return await apiGETPaginated('/api/clients', filters);
}

/**
 * Returns all the existing clients with pagination.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getClients() {
    return await apiGET('/api/clients');
}

/**
 * Returns all the existing clients without pagination.
 *
 * @returns {Promise<T|AxiosResponse<*>|*|null>}
 */
export async function getAllClientsWithoutPagination() {
    return await apiGET('/api/all-clients-without-pagination');
}

export async function getClientsFiltered(general_filter) {
    let data = {
        nif_or_name: general_filter
    }

    return await apiGET('/api/clients/general-filter', data);
}

/**
 * Returns the requested client.
 *
 * @param client_id
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getClient(client_id) {
    return await apiGET('/api/client/' + client_id);
}

/**
 * Creates a new client with the provided information.
 *
 * @param client
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function createClient(client) {
    return await apiPOST('/api/client', client);
}

/**
 * Updates the provided client with the new values.
 *
 * @param client
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function editClient(client) {
    return await apiPUT('/api/client/' + client.id, client);
}

/**
 * Deletes the provided client
 *
 * @param client
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function deleteClient(client) {
    return await apiDELETE('/api/client/' + client.id);
}
